import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { withLocale, stripLocaleFromPath, setCookieLocale, getLocaleFromPath, DEFAULT_LOCALE } from "@/lib/locale";

/**
 * Navigate while preserving the current locale prefix.
 * localizedTo("/pricing") -> "/pt/pricing" (if current locale is pt).
 */
export function useLocalizedNavigate() {
  const nav = useNavigate();
  const loc = useLocation();
  const { i18n } = useTranslation();
  const current = getLocaleFromPath(loc.pathname) || i18n.language?.slice(0, 2) || DEFAULT_LOCALE;

  const to = (path) => withLocale(current, path);
  const push = (path, opts) => nav(to(path), opts);
  const replace = (path) => nav(to(path), { replace: true });

  const switchLanguage = (nextLocale) => {
    setCookieLocale(nextLocale);
    i18n.changeLanguage(nextLocale);
    // Preserve the current page in the new locale
    const currentClean = stripLocaleFromPath(loc.pathname);
    nav(withLocale(nextLocale, currentClean + loc.search + loc.hash), { replace: true });
  };

  return { to, push, replace, current, switchLanguage };
}
